module.exports = __webpack_public_path__ + "static/media/cybertruck_black.0a08c527.png";